import React, { useState, useContext } from 'react'
import {
	Button,
	Card,
	CardBody,
	Col,
	Modal,
	Row
} from 'reactstrap'
import { SpinnerComponent } from 'react-element-spinner'

import { trigger } from '../../events/customEvents'
import AuctionsService from '../../services/AuctionsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'
import Enumeration from '../../enumeration'

/**
 * Modal for cancelling an auction.
 * BRD: Cancel removes unit from auction and places it in 'Pending' tab under Cancelled.
 * - Without bid: Simple confirmation
 * - With bid: Indicates unit is live and asks "are you sure"
 */
const CancelAuctionModal = ({ isOpen = false, auction = null, onClose, onSuccess }) =>
{
	const [isModalBusy, setIsModalBusy] = useState(false)
	const sessionContext = useContext(SessionContext)

	const handleCancelModal = () =>
	{
		if (typeof onClose === 'function')
		{
			onClose()
		}
	}

	const handleConfirmCancel = () =>
	{
		if (!auction) return

		// Create auction object with cancelled state
		const auctionToCancel = {
			...auction,
			auctionStateId: Enumeration.AuctionStates.Cancelled
		}

		setIsModalBusy(true)
		AuctionsService
			.cancelAuction(auctionToCancel, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				trigger('raiseNotification', { 
					title: 'Auction Cancelled', 
					message: 'The unit has been removed from auction and placed in the Pending tab.', 
					type: 'success', 
					duration: 5 
				})
				
				if (typeof onSuccess === 'function')
				{
					onSuccess()
				}
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}

	// Get VIN for display
	const vin = auction?.vin || auction?.vehicleVin || ''

	// Check if auction has bids
	const hasBids = auction?.hasBid || auction?.currentBid > 0 || auction?.bidAmount > 0

	return (
		<Modal
			className="modal-dialog-centered"
			size="md"
			isOpen={isOpen}
		>
			<SpinnerComponent
				loading={isModalBusy}
				position="centered"
				message="Processing..."
			/>
			<Card className="mb-0">
				<CardBody>
					{/* BRD: Title shows VIN and bid status */}
					<div className="text-muted mb-3">
						<strong>
							{hasBids ? `VIN:${vin} has a bid on it` : `VIN:${vin}`}
						</strong>
					</div>
					
					{/* BRD: Simple confirmation message */}
					<p className="mb-4">
						Are you sure you would like to cancel the auction at this time?
					</p>

					<Row>
						<Col className="text-center">
							<Button
								color="primary"
								className="me-2"
								onClick={handleConfirmCancel}
							>
								YES
							</Button>
							<Button
								color="secondary"
								onClick={handleCancelModal}
							>
								Cancel
							</Button>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Modal>
	)
}

export default CancelAuctionModal
